import * as React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons';
import { useSearchParams } from 'react-router-dom';
import { UseKeycloakService } from '@europrocurement/l2d-keycloak';
import { Button, Menu, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { useAvatarUrl } from '@europrocurement/flexy-components/providers';
import { useFullLayout } from '../../templates/FullLayout/FullLayoutContext';
import { ProfileDropdown, EntryType } from '../ProfileDropdown/ProfileDropdown';
import { CustomAvatar } from '../CustomAvatar';

export const ProfileDropdownOpener: React.FunctionComponent<{
    otherEntries?: EntryType[];
    manageAvatar?: React.ReactNode;
}> = function ({ otherEntries, manageAvatar }) {
    const keycloak = UseKeycloakService();

    const { jobName, toggleCustomizerDrawer } = useFullLayout();

    const logout = React.useCallback(() => keycloak.getKc().logout(), [keycloak]);

    const [profilDropdownOpened, setProfilDropdownOpened] = React.useState<Element | null>(null);

    const handleClose = () => setProfilDropdownOpened(null);
    const openProfilDropdown = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (event.target instanceof Element) setProfilDropdownOpened(event.currentTarget);
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [searchParams, setSearchParams] = useSearchParams();

    const openCustomizeFromProfile = (targetKey: string) => {
        setSearchParams((prev) => {
            prev.set('settingsTarget', targetKey);
            return prev;
        });
        setProfilDropdownOpened(null);
        toggleCustomizerDrawer();
    };

    const { avatarUrl } = useAvatarUrl();

    return (
        <>
            <Button
                aria-label="menu"
                color="inherit"
                aria-controls="profile-menu"
                aria-haspopup="true"
                onClick={openProfilDropdown}
            >
                <Stack
                    alignItems="center"
                    display="flex"
                    flexDirection="row"
                    gap={1.5}
                >
                    <CustomAvatar
                        firstName={keycloak.getName().split(' ')[0]}
                        lastName={keycloak.getName().split(' ')[1]}
                        src={avatarUrl}
                        sx={{
                            width: '32px',
                            height: '32px',
                        }}
                    />
                    <Typography
                        variant="l2dbodys"
                        color="text.gris50"
                    >
                        Bonjour,{' '}
                        <Typography
                            variant="l2dbodys"
                            color="text.primary"
                            fontWeight={700}
                        >
                            {keycloak.getName()}
                        </Typography>
                    </Typography>
                    <Typography
                        variant="l2dbodys"
                        color="text.gris70"
                        fontWeight={900}
                    >
                        <FontAwesomeIcon
                            width={16}
                            height={16}
                            icon={faChevronDown}
                            flip={profilDropdownOpened ? 'vertical' : undefined}
                        />
                    </Typography>
                </Stack>
            </Button>
            <Menu
                id="profile-menu"
                anchorEl={profilDropdownOpened}
                open={!!profilDropdownOpened}
                onClose={handleClose}
                sx={{
                    marginTop: '30px',
                }}
            >
                <Box width="385px">
                    <ProfileDropdown
                        jobName={jobName}
                        logout={logout}
                        onClose={handleClose}
                        openSettings={openCustomizeFromProfile}
                        otherEntries={otherEntries}
                        manageAvatar={manageAvatar}
                    />
                </Box>
            </Menu>
        </>
    );
};
